export default {
    namespaced: true,

    state: {
        loading: false,
        isDevelopment: false,
    },

    mutations: {
        toggleLoading(state) {
            state.loading = !state.loading && !state.isDevelopment;
        },
        cancelLoading(state) {
            state.loading = false;
        }
    },
};
